import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box } from '@mui/material';
import { withStyles } from '@mui/styles';
import LOCATION_TYPE from '../enum/location_type';

const styles = (theme) => ({
  tabsContainer: {
    display: 'inline-flex',
    width: 'fit-content',
    backgroundColor: '#f1f5f9',
    borderRadius: '8px',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05), 0 1px 3px rgba(15, 23, 42, 0.08)',
    border: '1px solid #e2e8f0',
    padding: '3px',
    position: 'absolute',
    zIndex: 1000,
    '& .MuiTabs-root': {
      minHeight: 'auto',
    },
    '& .MuiTabs-flexContainer': {
      gap: '2px',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  positionTopLeft: {
    top: '8px',
    left: '8px',
  },
  positionTopRight: {
    top: '8px',
    right: '8px',
  },
  positionInline: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
  },
  deliveryTab: {
    minWidth: 64,
    minHeight: 30,
    textTransform: 'none',
    fontSize: '0.75rem',
    fontWeight: 500,
    color: '#64748b',
    padding: '4px 12px',
    borderRadius: '6px',
    transition: 'all 0.15s ease',
    '&.Mui-selected': {
      color: '#ffffff',
      fontWeight: 600,
      backgroundColor: '#0369a1',
      boxShadow: '0 1px 3px rgba(3, 105, 161, 0.35)',
    },
    '&:hover:not(.Mui-selected)': {
      backgroundColor: '#e2e8f0',
      color: '#0f172a',
    },
  },
});

class DeliveryTypeTabs extends React.Component {
  getTabIndexFromLocationType = (locationTypeId) => {
    if (!locationTypeId) return 0;
    const deliveryTypes = this.getAvailableDeliveryTypes();
    const index = deliveryTypes.findIndex((type) => type.id === locationTypeId);
    return index >= 0 ? index : 0;
  };

  getAvailableDeliveryTypes = () => {
    const { locationtype } = this.props;

    if (locationtype && Array.isArray(locationtype) && locationtype.length > 0) {
      return locationtype;
    }

    return [
      { id: LOCATION_TYPE.Kiosk, label: 'Kiosk' },
      { id: LOCATION_TYPE.Counter, label: 'Counter' },
      { id: LOCATION_TYPE.Bedside, label: 'Bedside' },
      { id: LOCATION_TYPE.Courier, label: 'Courier' },
      { id: LOCATION_TYPE.Curbside, label: 'Curbside' },
    ];
  };

  handleTabChange = (event, newValue) => {
    const deliveryTypes = this.getAvailableDeliveryTypes();
    const selectedType = deliveryTypes[newValue];
    
    if (selectedType && this.props.onLocationTypeChange) {
      this.props.onLocationTypeChange(selectedType.id);
    }
    
  };

  render() {
    const { classes, onLocationTypeChange, position = 'topLeft' } = this.props;
    const deliveryTypes = this.getAvailableDeliveryTypes();
    const value = this.getTabIndexFromLocationType(this.props.selectedLocationTypeId);

    if (!onLocationTypeChange) {
      return null;
    }

    const positionClass = position === 'topRight' 
      ? classes.positionTopRight 
      : position === 'inline' 
        ? classes.positionInline 
        : classes.positionTopLeft;

    return (
      <Box className={`${classes.tabsContainer} ${positionClass}`}>
        <Tabs
          value={value}
          onChange={this.handleTabChange}
          variant="standard"
          aria-label="delivery type tabs"
        >
          {deliveryTypes.map((type, index) => (
            <Tab
              key={type.id}
              label={type.label}
              className={classes.deliveryTab}
              aria-label={`Switch to ${type.label} delivery`}
            />
          ))}
        </Tabs>
      </Box>
    );
  }
}

DeliveryTypeTabs.propTypes = {
  selectedLocationTypeId: PropTypes.string,
  onLocationTypeChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  locationtype: PropTypes.array,
  position: PropTypes.oneOf(['topLeft', 'topRight', 'inline']),
};

export default withStyles(styles)(DeliveryTypeTabs);



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/DeliveryTypeTabs.js